/* Secret Scenta: visible Klarna information and welcome dialog. Terms come from checkout. */
(function () {
  'use strict';

  var WELCOME_KEY = 'ss_welcome_seen_v1';
  function setHidden(el, hidden) {
    if (el && el.hidden !== hidden) el.hidden = hidden;
  }

  function openDialog(d) {
    if (!d || d.open) return;
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
  }
  function closeDialog(d) {
    if (!d) return;
    if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var opener = t.closest('[data-ss-klarna-open]');
    if (opener) {
      e.preventDefault();
      var info = document.querySelector('[data-ss-klarna-info]');
      if (!info) return;
      openDialog(info);
      return;
    }
    var closer = t.closest('[data-ss-dialog-close]');
    if (closer) { closeDialog(closer.closest('dialog')); return; }
    if (t.matches('dialog.ss-klarna-info, dialog.ss-welcome')) {
      var r = t.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(t);
    }
  });

  /* Fiche produit */
  function getPdp() { return document.querySelector('.pdp--journey') || document.querySelector('[data-pdp]'); }

  function pdpMention() {
    var pdp = getPdp();
    if (!pdp) return;
    var plan = pdp.querySelector('form [name="selling_plan"]');
    var pick = pdp.querySelector('.scent-pick[aria-pressed="true"]');
    var subscription = !!(plan && plan.value && !plan.disabled) ||
      !!(pick && pdp.querySelector('input[name="diffuser_scent_purchase"][value="subscription"]:checked'));
    var atc = pdp.querySelector('[data-atc]');
    var hide = subscription || !!(atc && atc.disabled);
    setHidden(pdp.querySelector('[data-ss-pdp-mention]'), hide);
    pdp.querySelectorAll('.ss-klarna-payment-icon').forEach(function (icon) { setHidden(icon, hide); });
  }

  /* setTimeout plutot que requestAnimationFrame : rAF est suspendu dans certains navigateurs integres / onglets en arriere-plan */
  var timer = 0;
  function schedulePdp() {
    if (timer) return;
    timer = window.setTimeout(function () { timer = 0; pdpMention(); }, 30);
  }

  function initPdp() {
    pdpMention();
    var pdp = getPdp();
    if (!pdp) return;
    document.addEventListener('change', function (e) {
      var p = getPdp();
      if (p && e.target && p.contains(e.target)) schedulePdp();
    });
    if (!window.MutationObserver) return;
    var root = pdp.closest('.shopify-section') || pdp.parentNode;
    new MutationObserver(schedulePdp).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-pressed'] });
  }

  /* Pop-up d'accueil */
  function welcomeSeen() {
    try { return window.localStorage.getItem(WELCOME_KEY) === '1'; } catch (e) { return true; }
  }
  function markWelcomeSeen() {
    try { window.localStorage.setItem(WELCOME_KEY, '1'); } catch (e) {}
  }
  function otherWindowOpen(welcome) {
    var open = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < open.length; i++) { if (open[i] !== welcome) return true; }
    var els = document.querySelectorAll('[role="dialog"], [aria-modal="true"]');
    for (var j = 0; j < els.length; j++) {
      var el = els[j];
      if (el.tagName === 'DIALOG' || welcome.contains(el)) continue;
      if (el.closest('#shopify-pc__banner') || /^shopify-pc/.test(el.id || '')) continue;
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && window.getComputedStyle(el).visibility !== 'hidden') return true;
    }
    return false;
  }
  function initWelcome() {
    var welcome = document.querySelector('[data-ss-welcome]');
    if (!welcome) return;
    var forced = /[?&]ss_welcome=1/.test(window.location.search);
    if (!forced && (welcomeSeen() || (window.Shopify && window.Shopify.designMode))) return;
    var tries = 0;
    function attempt() {
      if (otherWindowOpen(welcome)) {
        tries += 1;
        if (tries < 40) window.setTimeout(attempt, 1500);
        return;
      }
      openDialog(welcome);
      markWelcomeSeen();
    }
    window.setTimeout(attempt, forced ? 300 : 1500);
  }

  function init() { initPdp(); initWelcome(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', pdpMention);
})();
